import Vue from 'vue';
import store from '@/store';

export default {
  namespaced: true,
  state: {
    providerDetails: {
      timeModeOptions: [],
      countriesAndStates: [],
      providerTypes: [],
      specialities: [],
      countries: [],
    },
    bookingFilters: null,
    createdAppointment: null,
    paymentSuccess: false,
    clinicAdmin: {
      patient: null,
    },
    injuryIntake: null,
    injuryIntakeBypass: null,
    discardInjuryIntakeDraft: false,
  },
  mutations: {
    SET_INJURY_INTAKE: (state, payload) => { state.injuryIntake = payload; },
    RESET_INJURY_INTAKE: (state) => { state.injuryIntake = null; },
    SET_DISCARD_INJURY_INTAKE_DRAFT: (state, payload) => { state.discardInjuryIntakeDraft = payload; },
    SET_INJURY_INTAKE_BYPASS: (state, payload) => {
      state.injuryIntakeBypass = payload;
      state.injuryIntake = null;
    },
    RESET_INJURY_INTAKE_BYPASS: (state) => { state.injuryIntakeBypass = null; },
    SET_POVIDERS_FILTERS: (state, payload) => {
      if (payload) {
        state.providerDetails.timeModeOptions = payload.appointmentTypes;
        state.providerDetails.countries = Object.keys(payload.countries);
        state.providerDetails.countriesAndStates = payload.countries;
        state.providerDetails.providerTypes = payload.providerTypes;
        state.providerDetails.specialities = payload.specialities;
      }
    },
    SAVE_BOOKING_FILTERS: (state, filters) => state.bookingFilters = filters,
    SET_CREATED_APPOINTMENT: (state, appointment) => state.createdAppointment = appointment,
    SET_PAYMENT_SUCCESS: (state, paymentSuccess) => state.paymentSuccess = paymentSuccess,
    resetBookingFilters: state => state.bookingFilters = null,
    setCaPatient: (state, payload) => state.clinicAdmin.patient = payload,
    cleanCaPatient: (state) => state.clinicAdmin.patient = null,
  },
  actions: {
    getProviderFiltersOnMount: async ({ commit }, params) => {
      const clinicId = store.state.loggedAccount.account.clinicIds[0] || null;
      const nowTimeMode = params && params.timeMode && params.timeMode.toLowerCase() === 'now';

      const payload = {
        clinic: clinicId,
        fromDateTime: nowTimeMode || !params ? null : params.fromDateTime,
        toDateTime: nowTimeMode || !params ? null : params.toDateTime,
        communicationModes: ['InPerson', 'Video', 'Audio'],
        timezone: Vue.prototype.$timezone,
      };

      const response = await Vue.prototype.$api.providers.getProviderFilters(payload);
      commit('SET_POVIDERS_FILTERS', response.data.payload);
    },
    setProviderFilters: ({ commit }, params) => commit('SET_POVIDERS_FILTERS', params),
    saveBookingFilters: ({ commit }, params) => commit('SAVE_BOOKING_FILTERS', params),
    createAppointmentAction: async ({ commit, state }, appointment) => {
      const payload = { ...appointment };
      if (state.injuryIntakeBypass) {
        payload.injuryIntakeBypass = state.injuryIntakeBypass;
      } else if (state.injuryIntake) {
        payload.injuryIntake = state.injuryIntake;
      }
      const response = await Vue.prototype.$api.appointments.createAppointment(payload);
      commit('SET_CREATED_APPOINTMENT', response.data.payload);
      commit('RESET_INJURY_INTAKE');
      commit('RESET_INJURY_INTAKE_BYPASS');
    },
    createUrgentAppointmentAction: async ({ commit, state }, appointment) => {
      const payload = { appointment };
      if (state.injuryIntakeBypass) {
        payload.injuryIntakeBypass = state.injuryIntakeBypass;
      } else if (state.injuryIntake) {
        payload.injuryIntake = state.injuryIntake;
      }
      const response = await Vue.prototype.$api.urgent.createUrgentAppointment(payload);
      commit('SET_CREATED_APPOINTMENT', response.data.payload);
      commit('RESET_INJURY_INTAKE');
      commit('RESET_INJURY_INTAKE_BYPASS');
    },
    setPaymentSuccess: ({ commit }, payment) => commit('SET_PAYMENT_SUCCESS', payment),
  },
};
